
TS.ns('WL');

WL.leasingApplicationExposureModel = new Class({
    Extends: WL.leasingApplicationBaseModel,

    createProperties: function (config) {
        var me = this;

        me.parent(config);

        var grid = me.getDomainProperty('dgOfferExposure_Property');
        if (grid != null) {

            var cat = grid.Commands;
            newCmd = new TS.domain.Command();
            newCmd['Code'] = 'OpenOfferDetails';
            newCmd['Text'] = 'Offer Details';
            newCmd['handler'] = '_onOpenOfferDetails';
            newCmd['IconCode'] = 'folder-open-o';
            cat.push(newCmd);
        }

        var offerExposure = me.getDomainProperty('dgOfferExposure_Property');
        if (offerExposure) {
            offerExposure.on('cellValueChanged', me.onOfferExposureChanged, me);
        }

        var assetRiskList = me.getDomainProperty('AssetRiskList');

        if (assetRiskList != null) {

            assetRiskList.customiseOptions = function (options) {
                options.dataBound = function (e) {
                    var rows = e.sender.tbody.children();
                    var cols = e.sender.columns;
                    for (var j = 0; j < rows.length; j++) {
                        var row = $(rows[j]);
                        var dataItem = e.sender.dataItem(row);
                        var dcellActual = row.children().eq(3);

                        if ((dataItem.HighlightIfGreater === true && parseFloat(dataItem.Actual) > parseFloat(dataItem.Product)) || (dataItem.HighlightIfGreater === false && parseFloat(dataItem.Actual) < parseFloat(dataItem.Product))) {
                            dcellActual.addClass("scoring_financialIndicator_bold_red_row");
                        }
                    }
                }
            }
        }
    },

    _onOpenOfferDetails: function () {
        var me = this;

        var grid = me.getDomainProperty('dgOfferExposure_Property');
        if (grid.SelectedItem() == null) return;

        me.performServerCommand({
            cmd: 'ViewExposureOfferDetails',
            submitModel: true,
            extraData: { UID: grid.SelectedItem().UID() },
            blockUI: false
        });
    },

    onOfferExposureChanged: function (e) {
        var me = this,
            val = e.newValue;

        if (e.fieldName === 'IsSelected') {
            if (e.record.SelectableYN() != null && e.record.SelectableYN() == false) {
                e.record.IsSelected(false);
                return;
            }

            setTimeout(function () {
                me.performServerCommand({
                    cmd: 'TotalOfferExposure',
                    submitModel: true,
                    extraData: { IsSelected: e.newValue, rowIdx: e.rowIdx },
                    blockUI: true
                });
            }, 0)
        }

    }
});

